import { Theme, ThemeProvider } from '@mui/material/styles';
import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

interface ThemeContextType {
  theme: Theme;
  primaryColor: string;
  setPrimaryColor: (color: string) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext deve ser usado dentro de um ThemeProviderCustom');
  }
  return context;
};

export const ThemeProviderCustom = ({ children, theme }: { theme: Theme; children: ReactNode }) => {
  const [primaryColor, setPrimaryColor] = useState(theme.palette.primary.main);

  const defaultTheme = useMemo(() => {
    theme.palette.primary.main = primaryColor;
    return theme;
  }, [primaryColor, theme]);

  return (
    <ThemeContext.Provider value={{ theme: defaultTheme, primaryColor, setPrimaryColor }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
